module.exports = __webpack_public_path__ + "media/images/info_orange-2aaa5638fc8d57f9a9852f93db8cad3d.png";